import React, {memo, useState} from 'react'
import handwai_logo from "../Design/logo.png";
import {useHistory} from "react-router-dom";
import {Button, Col, Container, Form, Row} from "react-bootstrap";
import {checkPassword} from "../Utils/Common";
import {otpCode, sendEmail} from '../API/user';
import PasswordRuleSetComponent from "../Components/PasswordRuleSetComponent";


const logoStyle = {
    marginLeft: 20
};
const btnStyle = {
    backgroundColor: 'var(--handwai-green-color)',
    borderColor: 'var(--handwai-green-color)',
    color: 'var(--handwai-grey-1-color)',
    borderRadius: 0
};

function OTPPage() {

    const [firstPassword, setFirstPassword] = useState('');
    const [em, setUserName] = useState();
    const [otp, setOTPCode] = useState();
    const [pwd, setPassword] = useState();
    localStorage.clear();

    /**
     * Validates the first password entry from user and store it.
     * @param event
     */
    const handleFirstPasswordChange = (event) => {

        const tempFirstPassword = event.target.value;

        // Checks the password validation and animate the dots on UI
        checkPassword(tempFirstPassword)

        // Stores the first password user entry at OTP page.
        setFirstPassword(tempFirstPassword);
    }

    /**
     * Validates the second password entry from user and store it.
     * @param event
     */
    const handleSecondPasswordChange = (event) => {

        const tempSecondPassword = event.target.value;
        document.getElementById("c5").checked = (tempSecondPassword === firstPassword && tempSecondPassword !== '');
        setPassword(event.target.value);
    }

    /**
     * Verifies the both new passwords similarity and redirects to desired webpage, on 'WEITER' button click.
     * @param event
     */


    let history = useHistory();
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (checkPassword(firstPassword)) {
            const token = await otpCode({em, otp, pwd,});
            if (token.status===200) {
                let emaildetails = {
                    emailtype: "passwordchange",
                    emaildetails: {
                        username: token.username,
                        email: em
                    }
                }
                alert(JSON.stringify(token.message))
                await sendEmail(emaildetails)
                history.push(process.env.REACT_APP_FRONTEND_PATH_LOGIN);
            } else {
                alert('Bitte Eingaben überprüfen');
            }
        } else {
            alert('Bitte Eingaben überprüfen');
        }
    };


    return (
        <div>
            <br/>
            <header><img
                alt="Handwai GmbH Company Logo"
                src={handwai_logo}
                width="300"
                height="75"
                style={logoStyle}
            /></header>
            <br/><br/>

            <Row>
                <Col/>
                <Col>

                    <div className="container handwai-dark handwai-text-label-normal">

                        <Form onSubmit={handleSubmit}>
                            <br/>
                            <Container className="handwai-text-label-main">
                                <Row>

                                    <Col className="justify-content-center text-center">Passwort zurücksetzen</Col>
                                </Row>
                            </Container>

                            <br/>
                            <Form.Group controlId="formBasicEmail">
                                <Form.Label/>
                                <Form.Control type="email" className="handwai-input" placeholder="Email Adresse"
                                              onChange={event => setUserName(event.target.value)}/>
                            </Form.Group>
                            <br/>

                            <Form.Group controlId="formBasicEinmalpasswort">
                                <Form.Label/>
                                <Form.Control type="password" className="handwai-input" placeholder="Einmalpasswort"
                                              onChange={event => setOTPCode(event.target.value)}/>
                            </Form.Group>
                            <br/>

                            <Form.Group controlId="formBasicNeuesPasswort1">
                                <Form.Label/>
                                <Form.Control type="password" className="handwai-input"
                                              placeholder="Neues Passwort eingeben" maxLength="50"
                                              onChange={handleFirstPasswordChange}/>
                            </Form.Group>
                            <br/>

                            <Form.Group controlId="formBasicNeuesPasswort2">
                                <Form.Label/>
                                <Form.Control type="password" className="handwai-input"
                                              placeholder="Neues Passwort wiederholen" maxLength="50"
                                              onChange={handleSecondPasswordChange}/>
                            </Form.Group>
                            <br/>
                            <br/>
                            <Row>

                                <PasswordRuleSetComponent/>

                            </Row>

                            <br/>
                            <Row>
                                <Col className="d-flex justify-content-center"><Button className="handwai-btn-login"
                                                                                       style={btnStyle}
                                                                                       type="submit"
                                                                                       size="lg" block>
                                    WEITER </Button></Col>

                            </Row>
                            <br/>
                        </Form>
                    </div>
                </Col>

                <Col/>
            </Row>

            <br/><br/>
            <br/><br/>

        </div>
    );
}

export default memo(OTPPage);